<script lang="ts">
	import { BulletedList, Col, Row } from '@Shelly/shelly-design-system';
	import LottiePlayer from 'src/components/LottiePlayer/LottiePlayer.svelte';

	export let list;
	export let src;
</script>

<div class="step-content">
	<Row class="d-flex flex-direction-column">
		<Col sm="12" md="12" lg="12">
			<BulletedList class="mb-m" {list} />
		</Col>

		<div class="lottie-wrapper">
			<LottiePlayer
				{src}
				width={590}
				height={500}
				fillContainer
				showPreviewLabel={false}
				autoplay
				loop
			/>
		</div>
	</Row>
</div>

<style>
	.step-content {
		display: flex;
		flex-direction: column;
		height: 100%;
	}

	.lottie-wrapper {
		display: flex;
		flex: 1 1 auto;
		min-height: 0;
		width: 100%;
		justify-content: center;
		align-items: center;
	}
</style>
